export default class FigureZoom{

    constructor() {
        this._init();
    }

    _init(){
        this.$self = document.querySelector('.js-zoom');
        this.$inner = document.querySelector('.js-zoom__inner');
        this.$close = document.querySelector('.js-zoom__close');
        this._ui();
    }


    _ui(){
        
        [...document.querySelectorAll('.js-zoombtn')].forEach($opener => {

            $opener.addEventListener('click', ()=>{
                const $clone = $opener.querySelector('.js-zoomtarget').cloneNode(true);
                const bgcolor = $opener.getAttribute('data-bgcolor');
                if(bgcolor) this.$inner.style.backgroundColor = `#${bgcolor}`;
                this.$inner.appendChild($clone);
                this.$self.classList.add('-active');
            });
        });

        this.$close.addEventListener('click', () => {
            this.$self.classList.remove('-active');
            this.$inner.removeAttribute('style');
        });

        this.$self.addEventListener('transitionend', e => {
            if(e.currentTarget.classList.contains('-active')) return;
            this.$inner.innerHTML = '';
        });
    }
}